import store from '../store'

export default {
	hasRole(...roles) {
		return (to, from, next) => {
			if (roles.some(role => store.getters['auth/hasRole'](role))) {
				next()
				return
			}
			next('/login')
		}
	}
}
